<template>
  <div class="landing">
    <h1 v-html="title"></h1>

    <div class="landing__subtitle">
      
    </div>

    <p class="landing__subtitle2">Answer a few questions to find your perfect colour.</p>

    <AnimatedButton text ='Find your perfect on-trend colour'
               v-on:animated-click="getStarted()"></AnimatedButton>

  </div>
</template>

<script>
import AnimatedButton from './elements/AnimatedButton'
import {landing} from '../assets/data/data'

export default {
  name: 'Landing',
  components: { AnimatedButton },

  data() {
    return {
      title: landing.title,
    }
  },
  created() {
    
  },
  mounted() {
    this.updateSelectedColor()
	},
  methods: {
    updateSelectedColor() {
      this.$store.commit('updateSelectedColor', landing.colours)
      this.$store.commit('updateBg', [landing.colours.red, landing.colours.green, landing.colours.blue])
    },
    getStarted() {
      this.$router.push('/questions')
    }
  }

}
</script>
